jQuery(document).ready(function($) {
  
  /**/
  jQuery(window).scroll(function(){
    jQuery('.circle-show').each(function(){
      if(isScrolledIntoView($(this))){
        $(this).addClass("active")
      }
      /*else{
            $(this).addClass("non-active")
        }*/
    });
  });


  function isScrolledIntoView(elem){
    var $elem = jQuery(elem);
    var $window = jQuery(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  function equal(){
    var rightHeight = jQuery('.how-qs-sec .right-sec').height();
    var leftHeight = jQuery('.how-qs-sec .left-sec').height();
    var totalHeight = (rightHeight - leftHeight) / 2;
    //jQuery('.how-qs-sec .left-sec .hand-img').css("top", totalHeight + 30);
  };
  equal();

  function fixHeader(){
    var headHeight = jQuery('.site-header').outerHeight();
    jQuery('.page-container .main-content').css("margin-top", headHeight);
  };
  fixHeader();

  jQuery(window).resize(function() {
    fixHeader();
    equal();
  });

  jQuery(window).load(function() {
    equal();
  });


  jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 100) {
      jQuery('.site-header').addClass('active');
    } else {
      jQuery('.site-header').removeClass('active');
    }
  });

  /* product slider */
  var $status = $('.slider-paginginfo');
  var $slickElement = jQuery('.p-slider').slick({    
    infinite: false,
    slidesToShow: 1,
    //autoplay:true
  });

  //var $slickElement = $('.p-slider');
  //alert($slickElement.slick("getSlick").slideCount);
  $status.text('1 / ' + $slickElement.slick("getSlick").slideCount);

  $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + ' / ' + slick.slideCount);
  });

  /*
$slickElement.slick({    
    infinite: false,
    slidesToShow: 1,
  });*/
  /* END product slider */
  

  /*scroll pane*/
  var scrollPane = $(".scroll-pane").jScrollPane();
  jQuery('.nav-tabs a[data-toggle="tab"]').on('shown.bs.tab', function () {
    jQuery(".scroll-pane").jScrollPane();
  })
  jQuery(window).resize(function(event) {
    var scrollPane = $(".scroll-pane").jScrollPane();    
    jQuery('.nav-tabs a[data-toggle="tab"]').on('shown.bs.tab', function () {
      jQuery(".scroll-pane").jScrollPane();
    })
  });

  
  /*animation effects */
  // WOW JS
  new WOW({
    boxClass: 'wow', // default
    animateClass: 'animated', // default
    offset: 0, // default
    mobile: true, // default
    live: true // default
  }).init();
});



(function($) {
  $.fn.visible = function(partial) {

    var $t            = $(this),
        $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top,
        _bottom       = _top + $t.height(),
        compareTop    = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };  

  function checkWidth() {
    var windowSize = $(window).width();
    if (windowSize > 750) {
      $(window).scroll(function(event) {
        $(".how-col-data").each(function(i, el) {
          var el = $(el);
          if (el.visible(true + 500)) {
            el.addClass("fadeIn");  
          } else {
            el.removeClass("fadeIn");
          }
        });
      });
    }else{
      $(window).scroll(function(event) {
        $(".how-col-data").each(function(i, el) {
          var el = $(el);
          if (el.visible(true)) {
            el.addClass("fadeIn");             
          } else {
            el.removeClass("fadeIn");
          }
        });
      });
    }
  }
  checkWidth();
  // Bind event listener
  $(window).resize(checkWidth);  

})(jQuery);



/******* Price change based in Qty **********/
/****** Qty + - ********/
$(function() {
  $('.qtyplus').click(function(e){
    e.preventDefault();
    fieldName = $(this).attr('field');

    //Fetch qty in the current elements context and since you have used class selector use it.
    var qty = $(this).closest('div.quantity').find('.qty');
    //var qty = $(this).closest('tr').find('input[name='+fieldName+']');

    var currentVal = parseInt(qty.val());
    if (!isNaN(currentVal)) {			
      qty.val(currentVal + 1);			
    } else {
      qty.val(1);
    }

    //Trigger change event
    qty.trigger('change');
  });

  $(".qtyminus").click(function(e) {
    e.preventDefault();
    fieldName = $(this).attr('field');

    //Fetch qty in the current elements context and since you have used class selector use it.
    var qty = $(this).closest('div.quantity').find('.qty');
    //var qty = $(this).closest('tr').find('input[name='+fieldName+']');

    var currentVal = parseInt(qty.val());
    if (!isNaN(currentVal) && currentVal > 1) {
      qty.val(currentVal - 1);
    } else {
      qty.val(1);
    }

    //Trigger change event
    qty.trigger('change');
  });     

});

/*scroll js*/
/*
jQuery(document).ready(function($) {
  var jQueryelement = jQuery('.timeline');
  var jQuerywin = jQuery(window);
  var jQueryvis = jQuery('.line-before');

  jQuerywin.on('scroll', function () {
    //console.log(percentageSeen());
    jQueryvis.css('height',percentageSeen() + '%');
  });

  function percentageSeen () {
    var viewportHeight = jQuery(window).height(),
        scrollTop = jQuerywin.scrollTop(),
        elementOffsetTop = jQueryelement.offset().top,
        elementHeight = jQueryelement.height()-120;


    if (elementOffsetTop > (scrollTop + viewportHeight)) {
      return 0;
    } else if ((elementOffsetTop + elementHeight) < scrollTop) {
      return 100;
    } else {
      var distance = (scrollTop + viewportHeight) - elementOffsetTop;
      var percentage = distance / ((viewportHeight + elementHeight) / 100);
      percentage = Math.round(percentage);
      return percentage;
    }
  }

  jQuerywin.trigger('scroll');
});*/

/*affix

jQuery(document).ready(function($) {
  setTimeout(function(){
  var stickyNavTop = jQuery('.fixed-content').offset().top;
  stickyNavTop = stickyNavTop - jQuery('.site-header').outerHeight();
  var stickyNav = function(){
    var scrollTop = jQuery(window).scrollTop(); // our current vertical position from the top
    if (scrollTop > stickyNavTop) {
      jQuery('.fixed-content').addClass('sticky');
    } else {
      jQuery('.fixed-content').removeClass('sticky');
    }
  };
  stickyNav();
  jQuery(window).scroll(function() {
    stickyNav();
  });

  var stickyNavTop1 = jQuery('#shopify-section-custom-footer').offset().top;
  
  //alert(stickyNavTop1);
  sticky_header1 = jQuery('.site-header').height();
  sticky_right_menu1 = jQuery('.fixed-content').height();  
  sticky_map1 = jQuery('.p-map-sec').height();
  stickyNavTop1 = stickyNavTop1 - (sticky_header1 + sticky_right_menu1 + sticky_map1);
  //alert(stickyNavTop1);
  var stickyNav1 = function(){
    var scrollTop1 = jQuery(window).scrollTop(); // our current vertical position from the top
    if (scrollTop1 > stickyNavTop1) {
      jQuery('.fixed-content').removeClass('sticky');
	  jQuery('.fixed-content').css('position','relative');
	  var stickyforBottom = jQuery('.how-qs-sec .left-sec .hand-img').height() - jQuery('.fixed-content').height();
	 
      if (jQuery(window).width() > 1199) {
        jQuery('.fixed-content').css('top','510px');
      }
      else {
        jQuery('.fixed-content').css('top','580px');
      }	  
      
    } else {
		jQuery('.fixed-content').css('top','auto');      
    }
  };
  stickyNav1();
  jQuery(window).scroll(function() {
    stickyNav1();
  });
}, 6500);
  
  
  jQuery(window).scroll(function(event) {
    var header_height = jQuery('.site-header').outerHeight();
    var how_sec1 = jQuery('.how-col-data.1').offset().top - header_height;
    var how_sec2 = jQuery('.how-col-data.2').offset().top - header_height;
    var how_sec3 = jQuery('.how-col-data.3').offset().top - header_height;


    var scrollTop = jQuery(window).scrollTop(); // our current vertical position from the top

    if (scrollTop > how_sec3) {
      jQuery('.fixed-content').removeClass('image1 image2 image3');
      jQuery('.fixed-content').addClass('image3');
      var img3 = jQuery('.image3 .img img').attr("data-img3");
      jQuery('.image3 .img img').attr("src",img3);
    }
    else if (scrollTop > how_sec2) {
      jQuery('.fixed-content').removeClass('image1 image2 image3');
      jQuery('.fixed-content').addClass('image2');
      var img2 = jQuery('.image2 .img img').attr("data-img2");
      jQuery('.image2 .img img').attr("src",img2);
    }
    else if (scrollTop > how_sec1) {
      jQuery('.fixed-content').removeClass('image1 image2 image3');
      jQuery('.fixed-content').addClass('image1');
      jQuery('.image1 .img img').attr("src","//cdn.shopify.com/s/files/1/0091/1268/2558/files/moleculas_462x.jpg?v=1557485597");
    }

  }); 
  
});*/